module.exports = __webpack_public_path__ + "static/media/piano_annuale_bodybuilding.c5a557d9.jpg";